"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Decimals = void 0;
let Decimals = exports.Decimals = /*#__PURE__*/function (Decimals) {
  Decimals[Decimals["None"] = 0] = "None";
  Decimals[Decimals["One"] = 1] = "One";
  Decimals[Decimals["Two"] = 2] = "Two";
  return Decimals;
}({});
//# sourceMappingURL=Decimals.js.map